import React, { useState } from 'react'
import _ from 'lodash'
import Modal from './Modal'
import toast from './Toast'
import api from '../api'
import { updateToSent } from '../fire'

let SentStatusModal = ({ onClose, client, month, lead, leadNote }) => {
  let [clientAnswered, setClientAnswered] = useState(true)
  let [sendLeadEmail, setSendLeadEmail] = useState(client.sendLeadEmailDefault)
  let [sending, setSending] = useState(false)
  let initialEmailsIncluded = _(client.users)
    .filter(u => !u.excludeFromLeadNotifyEmail)
    .map('email')
    .value()
  let [userEmailsIncluded, setUserEmailsIncluded] = useState(
    initialEmailsIncluded
  )

  const markSent = async () => {
    setSending(true)

    try {
      let sentDate = Date.now()

      await updateToSent({
        month,
        clientId: lead.clientId,
        leadId: lead.leadId,
        leadNote,
        sentDate,
        ...lead,
      })

      if (sendLeadEmail) {
        await api('/trigger-lead-sent-email', {
          userEmails: userEmailsIncluded,
          clientAnswered,
          sentDate,
          clientId: lead.clientId,
          name: lead.name,
          phoneNumber: lead.phoneNumber,
          email: lead.email,
          address: lead.address,
          city: lead.city || '',
        })
        toast.success(`Lead email has been sent to client ${lead.clientId}`)
      }

      onClose()
    } catch (e) {
      toast.error(`There was an error sending the email to the client: ${e}`, {
        autoClose: false,
      })
    }
  }

  return (
    <Modal
      isOpen
      title="Send Lead"
      maxWidth="600px"
      onClose={() => onClose()}
      body={
        <div>
          {_.map(
            client.users,
            ({ name, email, tag, excludeFromLeadNotifyEmail }, id) => (
              <div key={id}>
                <input
                  type="checkbox"
                  className="ml-2"
                  checked={_.includes(userEmailsIncluded, email)}
                  disabled={!excludeFromLeadNotifyEmail}
                  onChange={e => {
                    let newEmails = e.target.checked
                      ? userEmailsIncluded.concat(email)
                      : userEmailsIncluded.filter(u => u !== email)

                    setUserEmailsIncluded(newEmails)
                  }}
                />{' '}
                {name} - {email}
                {tag && (
                  <span className="ml-3">
                    <i className="fa fa-tag" /> {tag}
                  </span>
                )}
              </div>
            )
          )}

          <div className="mt-4">
            <input
              type="checkbox"
              className="ml-2"
              checked={clientAnswered}
              onChange={e => setClientAnswered(e.target.checked)}
            />{' '}
            Client Answered?
          </div>

          <div className="mt-2">
            <input
              type="checkbox"
              className="ml-2"
              checked={sendLeadEmail}
              onChange={e => setSendLeadEmail(e.target.checked)}
            />{' '}
            Send Email
          </div>
        </div>
      }
      footer={closeModal => (
        <div>
          <button
            className="btn btn-danger"
            disabled={sending}
            onClick={() => onClose()}
          >
            Cancel
          </button>
          <button
            className="ml-2 btn btn-success"
            disabled={sending || _.isEmpty(userEmailsIncluded)}
            onClick={markSent}
          >
            {sendLeadEmail ? 'Send' : 'Mark Sent'}{' '}
            {sending && <i className="fa fa-spinner fa-spin" />}
          </button>
        </div>
      )}
    />
  )
}

export default SentStatusModal
